import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-news',
  styleUrls: ['./news.component.scss'],
  templateUrl: './news.component.html',
})
export class NewsComponent {}
